export default {
  menu: {
    backgroundColor: "#DBE7F6",
    fontSize: "16px",
    position: "sticky",
    top: 0,
    width: "377px",
  },
  menuTag: {
    alignItems: "center",
    borderRadius: "15px",
    height: "30px",
    justifyContent: "center",
    width: "30px",
  },
};
